import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=1663b376&scoped=true"
import script from "./FooterNav.vue?vue&type=script&lang=js"
export * from "./FooterNav.vue?vue&type=script&lang=js"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=1663b376&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1663b376",
  null
  
)

export default component.exports